
export function TmbConfirmPlanniLiterals(t: any) {
  return {
    titlePage: t("titlePage"),
    title: t("title"),
    description:t("description"),
    link:t("link"),
    leftButton: {
      type:  t("leftButton.type"),
      text: t("leftButton.text"),
      id: t("leftButton.id"),
    },
    imageSection: {
      name: t("imageSection.name"),
      alt: t("imageSection.alt"),
    },
    tag: t("tag")
  };
}

